/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Beam_FtInputs */

const en_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beam (ft)`)
};

const es_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manga (pies)`)
};

const fr_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largeur (ft)`)
};

const de_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breite (ft)`)
};

const ja_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全幅 (フィート)`)
};

const zh_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`船宽 (英尺)`)
};

const ar_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض السفينة (بالقدم)`)
};

const id_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebar (ft)`)
};

const it_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larghezza (ft)`)
};

const ru_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ширина судна (футы)`)
};

const pt_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boca (pés)`)
};

const ko_field_beam_ft = /** @type {(inputs: Field_Beam_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선폭 (ft)`)
};

/**
* | output |
* | --- |
* | "Beam (ft)" |
*
* @param {Field_Beam_FtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_beam_ft = /** @type {((inputs?: Field_Beam_FtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Beam_FtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_beam_ft(inputs)
	if (locale === "es") return es_field_beam_ft(inputs)
	if (locale === "fr") return fr_field_beam_ft(inputs)
	if (locale === "de") return de_field_beam_ft(inputs)
	if (locale === "ja") return ja_field_beam_ft(inputs)
	if (locale === "zh") return zh_field_beam_ft(inputs)
	if (locale === "ar") return ar_field_beam_ft(inputs)
	if (locale === "id") return id_field_beam_ft(inputs)
	if (locale === "it") return it_field_beam_ft(inputs)
	if (locale === "ru") return ru_field_beam_ft(inputs)
	if (locale === "pt") return pt_field_beam_ft(inputs)
	return ko_field_beam_ft(inputs)
});